import React, { useState, useEffect } from 'react';
import { Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Add this import
import DashboardIcon from '@mui/icons-material/Dashboard';
import dashboardIcon from '../assets/dashboard-icon.svg';
import { useAuth } from '../contexts/AuthContext';

// Add import for voucher icon
import VoucherIcon from '@mui/icons-material/LocalOffer';
import AffiliateIcon from '@mui/icons-material/Person';
import UserIcon from '@mui/icons-material/People';

// Add import for VoucherForm
import VoucherForm from './VoucherForm';
import AffiliateForm from './AffiliateForm';
import Referral from './Referral';
import TopNav from './TopNav';
import UserManagement from './UserManagement';
import Analytics from './Analytics';
import ListAffiliate from './ListAffiliate';

const Dashboard = () => {
  const navigate = useNavigate(); // Add this hook for navigation
  const [setSummary] = useState({
    totalVouchers: 3,
    totalReward: 12000000,
    totalUsers: 3000
  });
  const [vouchers] = useState([]);
  const [filteredVouchers, setFilteredVouchers] = useState([]);
  const [setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig] = useState({ key: null, direction: 'ascending' });
  const [activeMenu, setActiveMenu] = useState('referral');
  const isMobile = useMediaQuery('(max-width:768px)');
  const { currentUser, hasRole } = useAuth();

  // Define menu items with role requirements
  // Update menuItems array
  const menuItems = [
    {
      id: 'referral',
      name: 'Referral SalingJaga',
      icon: dashboardIcon,
      isIcon: false,
      requiredRoles: ['affiliate'],
    },
    {
      id: 'voucher',
      name: 'Voucher Management',
      icon: VoucherIcon,
      isIcon: true,
      requiredRoles: ['admin'],
    },
    {
      id: 'affiliate',
      name: 'Affiliate Management',
      icon: AffiliateIcon,
      isIcon: true,
      requiredRoles: ['admin'],
    },
    {
      id: 'list-affiliate',
      name: 'List Affiliate',
      icon: AffiliateIcon,
      isIcon: true,
      requiredRoles: ['referral_manager'],
    },
    {
      id: 'analytics',
      name: 'Analytics Dashboard',
      icon: DashboardIcon,
      isIcon: true,
      requiredRoles: ['admin', 'referral_manager'],
    },
    {
      id: 'users',
      name: 'User Management',
      icon: UserIcon,
      isIcon: true,
      requiredRoles: ['admin'],
    },
  ];

  // Filter menu items based on user roles
  const filteredMenuItems = menuItems.filter(item => {
    // If no required roles, show to everyone
    if (!item.requiredRoles || item.requiredRoles.length === 0) return true;
    
    // Check if user has any of the required roles
    return item.requiredRoles.some(role => hasRole(role));
  });

  useEffect(() => {
    const loadData = async () => {
      // setLoading(true);
      try {
      
        // // Fetch voucher data
        // const voucherData = await fetchPartnerVouchers('1');
        // setVouchers(voucherData);
        // setFilteredVouchers(voucherData);
      } catch (error) {
        console.error('Error loading dashboard data:', error);
      } finally {
        // setLoading(false);
      }
    };

    loadData();
  }, [setSummary]);
  
  // Apply search filter
  useEffect(() => {
    if (searchQuery) {
      const filtered = vouchers.filter(voucher => 
        voucher.code.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredVouchers(filtered);
      setPage(1); // Reset to first page when searching
    } else {
      setFilteredVouchers(vouchers);
    }
  }, [searchQuery, vouchers, setPage]);
  
  // Apply sorting
  useEffect(() => {
    if (sortConfig.key) {
      const sortedVouchers = [...filteredVouchers].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
      setFilteredVouchers(sortedVouchers);
    }
  }, [sortConfig, filteredVouchers]);
  
  const handleSearch = (query) => {
    setSearchQuery(query);
  };
  
  // Handle menu item click - update this function
  const handleMenuClick = (menuItem) => {
    if (menuItem === 'referral') {
      // Navigate to the separate Referral page
      navigate('/referral');
    } else {
      // For other menu items, just update the active menu
      setActiveMenu(menuItem);
    }
  };
  
  return (
    <div className="app-container">
      {/* Sidebar */}
      <div className={`sidebar ${isMobile ? 'mobile-sidebar' : ''}`}>
        <div className="sidebar-logo">
          <div className="user-avatar">KS</div>
          <Typography variant="subtitle1" fontWeight="bold">
            {currentUser.displayName}
          </Typography>
        </div>
        <Typography className="sidebar-title">Affiliate Dashboard</Typography>
        <ul className="sidebar-menu">
          {filteredMenuItems.map(item => (
            <li 
              key={item.id}
              className={`sidebar-menu-item ${activeMenu === item.id ? 'active' : ''}`}
              onClick={() => handleMenuClick(item.id)}
            >
              <span className="icon">
                {item.isIcon ? (
                  <item.icon className="menu-icon" />
                ) : (
                  <img src={item.icon} alt={item.name} className="menu-icon" />
                )}
              </span>
              <span>{item.name}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Main Content with TopNav */}
      <div className="content-wrapper">
        <TopNav onSearch={handleSearch} />
        
        {activeMenu === 'referral' ? (
          <div className="main-content">
            <Referral />
          </div>
        ) : activeMenu === 'shorturl' ? (
          // <ShortUrl />
          <div className="main-content">Empty</div>
        ) : activeMenu === 'analytics' ? (
          <div className="main-content">
            <Analytics />
          </div>
        ) : activeMenu === 'users' ? (
          <div className="main-content">
            <UserManagement />
          </div>
        ) : activeMenu === 'voucher' ? (
          <div className="main-content">
            <VoucherForm partnerId={currentUser.uid} />
          </div>
        ) : activeMenu === 'affiliate' ? (
          <div className="main-content">
            <AffiliateForm />
          </div>
        ) : activeMenu === 'list-affiliate' ? (
          <div className="main-content">
            <ListAffiliate />
          </div>
        ) : (
          <div className="main-content">
            <h2>Page Not Found</h2>
            <p>The selected menu item doesn't have a corresponding view.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
